import React from "react";
import styles from "./topBanner.scss";
import { useSelector } from "react-redux";
import { find } from "lodash";

function TopBanner(props) {
  const {
    heading,
    description,
    productCount,
    mobileHeadingColor,
    desktopHeadingColor,
    backgroundColor,
    mobileBackgroundImage,
    desktopBackgroundImage,
    displayProductCount,
  } = props;

  const navigationsData = useSelector(
    (state) => state.plpState && state.plpState.navigation
  );

  const categoryCode = useSelector(
    (state) => state.plpState && state.plpState.categoryCode
  );

  const navObj = find(navigationsData, {
    categoryCode: categoryCode,
  });
  const categoryName = heading ? heading : navObj?.categoryName;

  return (
    <>
      <div
        className={styles["mobile-banner"]}
        style={{
          backgroundColor: backgroundColor ? backgroundColor : "#F0F9FF",
        }}
      >
        <div className={styles["mobile-img"]}>
          {mobileBackgroundImage ? (
            <img src={mobileBackgroundImage} alt="" />
          ) : null}
        </div>
        <div>
          <h1
            style={{ color: mobileHeadingColor }}
            className={styles["heading"]}
          >
            {categoryName}
          </h1>
          {displayProductCount && (
            <div
              style={{ color: mobileHeadingColor }}
              className={styles["product-number"]}
            >
              ({productCount ? productCount : 0})項商品
            </div>
          )}
        </div>
      </div>
      <div className={styles["desktop-banner"]}>
        <div
          style={{
            backgroundColor: backgroundColor ? backgroundColor : "#F0F9FF",
          }}
          className={
            desktopBackgroundImage
              ? styles["desktop-w-content"]
              : styles["desktop-wo-content"]
          }
        >
          <div className={styles["desktop_heading_and_count"]}>
            <h1
              style={{ color: desktopHeadingColor }}
              className={styles["desktop-heading"]}
              title={categoryName}
            >
              {categoryName}
            </h1>
            {description && (
                <div
                  style={{ color: desktopHeadingColor }}
                  className={styles["desktop-description"]}
                  title={description}
                >
                  {description}
                </div>
            )}

            {displayProductCount && (
              <div
                style={{ color: desktopHeadingColor }}
                className={styles["desktop-product-number"]}
              >
                ({productCount ? productCount : 0})項商品
              </div>
            )}
          </div>

          {desktopBackgroundImage && (
            <div className={styles["desktop-background-img"]}>
              <div className={styles["banner-desk-img"]}>
                {desktopBackgroundImage ? (
                  <img src={desktopBackgroundImage} alt="" />
                ) : null}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

TopBanner.defaultProps = {
  displayProductCount: true,
};

export default TopBanner;
